import React from "react";

import {
  MdLibraryBooks,
  MdLocationCity,
  MdScience,
  MdSportsCricket,
} from "react-icons/md";

import { FaArrowRight } from "react-icons/fa";

const facilities = [
  {
    title: "Central Library",
    icon: MdLibraryBooks,
    image:
      "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=1000&q=80",
    desc:
      "A rich learning space with books, digital resources and a peaceful reading environment.",
    features: [
      "10,000+ Books",
      "Digital Library",
      "Reading Hall",
      "E-Resources",
    ],
  },
  {
    title: "Sports Complex",
    icon: MdSportsCricket,
    image: "/image3.png",
    desc:
      "Modern facilities for outdoor and indoor sports to nurture fitness, teamwork and athletic talent.",
    features: [
      "Cricket Ground",
      "Basketball Court",
      "Indoor Games",
      "Sports Training",
    ],
  },
  {
    title: "Science Labs",
    icon: MdScience,
    image: "/lab.png",
    desc:
      "Well-equipped laboratories for practical learning in Physics, Chemistry, Biology and Computers.",
    features: [
      "Physics Lab",
      "Chemistry Lab",
      "Biology Lab",
      "Computer Lab",
    ],
  },
  {
    title: "Smart Campus",
    icon: MdLocationCity,
    image: "/image1.png",
    desc:
      "A technology-enabled and secure campus designed to support modern teaching and learning.",
    features: [
      "Smart Classes",
      "Wi-Fi Campus",
      "CCTV Security",
      "Eco-Friendly Campus",
    ],
  },
];

const Facilities = () => {
  return (
    <section className="relative w-full overflow-hidden bg-gradient-to-br from-gray-50 via-white to-red-50 py-8 sm:py-10 lg:py-12">
      {/* Background decoration */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -right-28 -top-24 h-72 w-72 rounded-full bg-red-200/25 blur-3xl" />

        <div className="absolute -bottom-28 -left-24 h-72 w-72 rounded-full bg-yellow-200/25 blur-3xl" />
      </div>

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-10 xl:px-16">
        {/* Heading */}
        <div className="mb-7 text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-red-200 bg-white px-4 py-2 text-xs font-black uppercase tracking-[0.13em] text-red-700 shadow-sm">
            <span className="h-2 w-2 animate-pulse rounded-full bg-red-600" />

            Premium Infrastructure

            <span className="h-2 w-2 animate-pulse rounded-full bg-yellow-500" />
          </div>

          <h2 className="mt-3 font-serif text-3xl font-black text-slate-950 sm:text-4xl lg:text-[44px]">
            World-Class{" "}
            <span className="relative inline-block text-red-700">
              Facilities

              <span className="absolute -bottom-1 left-0 h-1 w-full rounded-full bg-gradient-to-r from-red-700 to-yellow-500" />
            </span>
          </h2>

          <p className="mx-auto mt-3 max-w-2xl text-sm leading-6 text-slate-500 sm:text-[15px]">
            Modern infrastructure and thoughtfully designed
            learning spaces that support academic, physical
            and personal development.
          </p>
        </div>

        {/* Cards */}
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {facilities.map((item, index) => {
            const Icon = item.icon;

            return (
              <article
                key={item.title}
                className="facility-card group relative overflow-hidden rounded-[20px] border border-red-100 bg-white shadow-[0_12px_35px_rgba(100,20,20,0.08)] transition duration-500 hover:-translate-y-1.5 hover:shadow-[0_22px_50px_rgba(100,20,20,0.16)]"
                style={{
                  animationDelay: `${index * 0.1}s`,
                }}
              >
                <div className="relative h-[180px] overflow-hidden sm:h-[195px] lg:h-[205px]">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="h-full w-full object-cover transition duration-700 group-hover:scale-110"
                    loading="lazy"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />

                  <div className="absolute right-4 top-4 flex h-11 w-11 items-center justify-center rounded-xl border border-white/30 bg-black/25 text-2xl text-white shadow-md backdrop-blur-md transition duration-300 group-hover:rotate-6 group-hover:bg-red-700">
                    <Icon />
                  </div>

                  <div className="absolute bottom-4 left-4 right-4">
                    <p className="text-[10px] font-black uppercase tracking-[0.15em] text-yellow-400">
                      St. Xavier&apos;s Bela
                    </p>

                    <h3 className="mt-1 font-serif text-2xl font-black text-white">
                      {item.title}
                    </h3>
                  </div>
                </div>

                <div className="p-4">
                  <p className="min-h-[60px] text-sm leading-5 text-slate-600">
                    {item.desc}
                  </p>

                  <div className="mt-3 flex min-h-[58px] flex-wrap content-start gap-1.5">
                    {item.features.map((feature) => (
                      <span
                        key={feature}
                        className="rounded-full border border-red-100 bg-red-50 px-2.5 py-1 text-[10px] font-semibold text-red-700 transition group-hover:border-yellow-200 group-hover:bg-yellow-50 group-hover:text-yellow-800"
                      >
                        {feature}
                      </span>
                    ))}
                  </div>

                  <button
                    type="button"
                    className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-red-700 transition-all duration-300 group-hover:gap-3"
                  >
                    Explore More

                    <FaArrowRight
                      size={11}
                      className="transition-transform duration-300 group-hover:translate-x-1"
                    />
                  </button>
                </div>

                <div className="absolute bottom-0 left-0 h-1 w-full origin-left scale-x-0 bg-gradient-to-r from-red-700 to-yellow-500 transition-transform duration-500 group-hover:scale-x-100" />
              </article>
            );
          })}
        </div>
      </div>

      <style>{`
        @keyframes facilityFadeIn {
          from {
            opacity: 0;
            transform: translateY(22px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .facility-card {
          opacity: 0;
          animation: facilityFadeIn 0.6s ease-out forwards;
        }
      `}</style>
    </section>
  );
};

export default Facilities;